import { render, staticRenderFns } from "./TemporaryReferralsIndexListing.vue?vue&type=template&id=3dd2a246"
import script from "./TemporaryReferralsIndexListing.vue?vue&type=script&lang=js"
export * from "./TemporaryReferralsIndexListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports